import React from 'react';
import { SlButton } from '@shoelace-style/shoelace/dist/react';
import { ButtonStyles } from './button.styles';

const Button = ({ children, click = () => {}, loading = false }) => {
  return (
    <ButtonStyles>
      <SlButton className={'button'} onClick={() => click()} loading={loading}>
        {children}
      </SlButton>
    </ButtonStyles>
  );
};

export default Button;
